export enum IsLoadingType {
  NORMAL,
  DURING,
  UNTIL,
}

// null for isLoadingType or isLoading is used to indicate that an
// action is being sent to update it, without neccisarily updating behavior
export interface IsLoadingDataInterface {
  isLoading?: boolean;
  // note: if isLoadingType is specified action MUST be specified
  type?: IsLoadingType;
  action?: string;
}
